import { render, staticRenderFns } from "./updateAuthority.vue?vue&type=template&id=3523b50c&lang=pug&"
import script from "./updateAuthority.vue?vue&type=script&lang=js&"
export * from "./updateAuthority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports